/// <amd-module name="Search/Shared/Components/SearchInput/index" />

export * from "./SearchInput";
export * from "./SearchInput.Props";
